import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Error/Error.scss';
import './Success/Success.scss';

const notifyConfigure = (status, isSuccess, message, isToastfy) => {
	const mainConfig = {
		position: 'top-center',
		hideProgressBar: true,
		closeButton: false,
		closeOnClick: true,
		draggable: true,
		pauseOnHover: true,
		pauseOnFocusLoss: true,
	};

	// under 300
	if (isToastfy?.success && status <= 300) {
		setTimeout(() => {
			toast.success(message, {
				...mainConfig,
				className: 'Toastify-success',
				autoClose: 1000,
				icon: <i style={{ color: '#fff !important', fontSize: 18 }} className="icon-tick-circle" />,
			});
		}, 200);
	}

	// above 300
	if (isToastfy?.error && status >= 300) {
		setTimeout(() => {
			toast.error(message, {
				...mainConfig,
				className: 'Toastify-error',
				autoClose: 1000,
				icon: <i style={{ color: '#fff !important', fontSize: 18 }} className="icon-error" />,
			});
		}, 200);
	}

	// for status code customize
	// write your notify
};

export default notifyConfigure;
